import {
  Accordion,
  AccordionDetails,
  Autocomplete,
  Badge,
  Box,
  Button,
  ButtonGroup,
  Chip,
  Grid,
  IconButton,
  List,
  ListItem,
  MenuItem,
  Paper,
  Select,
  Stack,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
} from '@mui/material';
import useWindowsDimension from 'functions/useWindowsDimension';
import 'moment-timezone';
import { useEffect, useReducer, useState } from 'react';

import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import { ticketCommunicationStatus, ticketStatusInterface } from 'data/enum';
import { rq, rqPost } from 'http/apiRoutes';
import { useGet, usePost, usePut } from 'http/useApi';
import { useParams } from 'react-router';
//@ts-ignore
import DocumentUploader from 'components/ui/DocumentUploader';
//@ts-ignore
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DevicesOtherRoundedIcon from '@mui/icons-material/DevicesOtherRounded';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import LocalActivityRoundedIcon from '@mui/icons-material/LocalActivityRounded';
import PersonSearchRoundedIcon from '@mui/icons-material/PersonSearchRounded';
import PriorityHighRoundedIcon from '@mui/icons-material/PriorityHighRounded';
import { DesktopDateTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { ICompanyViewModel } from 'Interfaces/ICompaniesConfig';
import { ICompanyProductViewModel } from 'Interfaces/ICompanyProductConfig';
import { IEmployeeViewModel } from 'Interfaces/IEmployeeConfig';
import {
  EnumObjectType,
  EnumOrderPostStatus,
  EnumPriority,
  EnumProductVariant,
  EnumScheduleType,
  EnumSubButtonInterface,
  EnumTicketStatus,
  IAddressViewModel,
  IDeliveryAddressViewModel,
  SubButtonInterface,
  objectArray,
} from 'Interfaces/IGlobalTypeConfig';
import { IProductViewModel } from 'Interfaces/IProductConfig';
import { FormAccordionSummary, FormBox } from 'components/form';
import { CompaniesDrawer } from 'components/ui/Drawers/CompaniesDrawer';
import { EmployeeDrawer } from 'components/ui/Drawers/EmployeeDrawer';
import { ScheduleView } from 'components/ui/ScheduleView';
import { SingleAutoAnswerView } from 'components/ui/SingleAutoAnswerView';
import { SingleCompanyProductView } from 'components/ui/SingleCompanyProductView';
import { SingleProductView } from 'components/ui/SingleProductView';
import { SingleTicketCompanyView } from 'components/ui/SingleTicketCompanyView';
import { SingleTicketContactProduct } from 'components/ui/SingleTicketContactProduct';
import { SingleTicketEmployeeView } from 'components/ui/SingleTicketEmployeeView';
import { SwitchType } from 'components/ui/SwitchType';
import { SingleMessage } from 'components/ui/tickets/SingleMessage';
import {
  ProductFormStyle,
  TextStyle,
  boxStyle,
  gridStyle,
} from 'data/FontStyle';
import { IRateViewModel, IWorkRoleViewModel } from 'data/atoms/atomConfig';
import ownerAtom from 'data/atoms/ownerAtom';
import qtyUpdate from 'data/atoms/qtyUpdate';
import userAtom from 'data/atoms/userAtom';
import dayjs from 'dayjs';
import CalculateTotalTime from 'functions/CalculateTotalTime';
import { ConvertToAttachment } from 'functions/ConvertToAttachment';
import { ConvertToPutTicketPost } from 'functions/ConvertToPutTicketPost';
import { ConvertToTicketPost } from 'functions/ConvertToTicketPost';
import { GenerateAddressList } from 'functions/Converters';
import { EconomyView } from 'functions/EconomySimpleView';
import GetPriorityColor from 'functions/GetPriorityColor';
import { GetWorkRole } from 'functions/GetWorkRole';
import { isGuidEmpty, isValidGuid } from 'functions/GuidChecks';
import { checkForOvertime } from 'functions/checkForOvertime';
import { useGetObjectList } from 'functions/useGetObjectList';
import { useAtom } from 'jotai';
import _ from 'lodash';
import { IAutoAnswersViewModel } from 'pages/AutoAnswersConfig';
import { ObjectDrawer } from 'pages/Companies/ObjectDrawer';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import {
  IEmployeeWithCompanyViewModel,
  ITicketPostViewModel,
} from '../../Interfaces/ITicketConfig';
import { ProductDrawer } from '../../components/ui/Drawers/ProductDrawer';
import { ServiceProductDrawer } from '../../components/ui/Drawers/ServiceProductDrawer';
import { RootReducer, initialRootState } from './Components/RotTicketReducer';
import {
  TicketHeaderButtonDetail,
  TicketProductViewInterface,
} from './Components/TicketStyleConfig';
import { ConvertStateToTicketUpdateWithProductViewModel } from './TicketDetails';
import { InvestmentProductDrawer } from 'components/ui/Drawers/InvestmentProductDrawer';
import { OrderPostProductViewModel } from 'pages/Orders/ViewModels/OrderPostViewModels';
import { TicketProductDrawer } from 'components/ui/Drawers/TicketProductDrawer';
import { SingleTicketProductView } from 'components/ui/SingleTicketProductView';

export const TicketCommunications = () => {
  const { t } = useTranslation();
  /* INITIALIZATIONS */
  const [owner] = useAtom(ownerAtom);
  const [user] = useAtom(userAtom);
  // console.log('userAtom', user);
  const [state, dispatch] = useReducer(RootReducer, initialRootState);
  let navigate = useNavigate();

  const [isQtyUpdate, setIsQtyUpdate] = useAtom(qtyUpdate);

  const { ticketId } = useParams<{ ticketId: string }>();
  const { height } = useWindowsDimension();

  const [selectedDocuments, setSelectedDocuments] = useState<any>([]);
  
  const [isObjectList, setIsObjectList] = useState<boolean>(true);
  let companyId = 'new';
  let employeeId = 'new';
  let departmentId = 'new';
  let resourceId = 'new';
  let objectDrawerList: objectArray[] = useGetObjectList(
    companyId ?? 'new',
    employeeId ?? 'new',
    departmentId ?? 'new',
    resourceId ?? 'new',
    isObjectList
  );

  // API CALLS

  let isEnabled = ticketId !== 'new' ? true : true;
  const { data: ticketData } = useGet(
    rq.ticket(ticketId || '', isEnabled, '0'),
  );
  const { data: ticketProductsData } = useGet(
    rq.ticketProducts(ticketId || '', isEnabled),
  );
  useEffect(() => {
    console.log('ticketProductsData', ticketProductsData);
    if (ticketProductsData) {
      dispatch({
        type: 'SET_CONSUMABLE_PRODUCTS',
        payload: ticketProductsData.consumables,
      });
      dispatch({
        type: 'SET_INVESTMENT_PRODUCTS',
        payload: ticketProductsData.investmentProducts,
      });
      dispatch({
        type: 'SET_AGREEMENT_PRODUCTS',
        payload: ticketProductsData.agreementProducts,
      });
      dispatch({
        type: 'SET_TICKET_PRODUCTS',
        payload: ticketProductsData.ticketProducts,
      });
      console.log('1. ticketProductsData', ticketProductsData);
    }
  }, [ticketProductsData]);
  const postTicketPost = usePost(rqPost.ticketPost(ticketId || '', '0'));
  const putTicketPost = usePut(
    rqPost.ticketPostPut(ticketId || '', state.ticketPost.ticketPost.id || '')
  );
  const putTicketResponsible = usePut(
    rqPost.ticketResponsible(ticketId || '', isEnabled),
  );

  const putTicket = usePut(rqPost.ticketPut(ticketId || '', '0', isEnabled));
  const { data: ticketPostDataList } = useGet(
    rq.ticketPosts(ticketId || '', true)
  );
  isEnabled = owner.id ? true : false;

  const { data: workRoleData } = useGet(
    rq.workRoles(owner.id, isEnabled),
  );

  isEnabled = state.ticketPost.rates.length <= 0 ? true : false;
  const { data: ratesData } = useGet(rq.rates(isEnabled));

  type FormOrMouseEvent =
    | React.FormEvent<HTMLFormElement>
    | React.MouseEvent<HTMLDivElement, MouseEvent>;

  // Lokale "inputValue"‐stater kun for validering
  const [toInput, setToInput] = useState<string>('');
  const [ccInput, setCcInput] = useState<string>('');
  const [postToInput, setPostToInput] = useState<string>('');
  const [postCcInput, setPostCcInput] = useState<string>('');

  // Hent e-poster fra combined state
  const toTicketEmails = state.ticket.toEmailList;
  const ccTicketEmails = state.ticket.ccEmailList;
  const toPostEmails = state.ticketPost.ticketPost.toEmailList;
  const ccPostEmails = state.ticketPost.ticketPost.ccEmailList;

  const isListDisabled =
  state.ticket.isDirty || state.ticketPost.ticketPost.isDirty;


  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  console.log('1. RERENDER TICKET DETAILS', state.products.ticketProducts);

  // 1) Felles oppdatering av e-postliste (TO eller CC, Ticket eller TicketPost),
  //    uten at vi flytter e-poster fra TO over i CC.
  //    Hvis en e-post ligger i TO, skal den forbli i TO, og ikke dukke opp i CC.
  //    All speiling til TicketPost (TO union, CC union) skjer kun fra Ticket‐endringer.
  //    Endringer i TicketPost berører kun TicketPost‐listen.
  // ----------------------------------------------------------------------------
  const handleEmailsChange =
    (context: 'TICKET' | 'TICKETPOST', field: 'TO' | 'CC') =>
    (_event: React.SyntheticEvent, newValue: string[]) => {
      // 1) Deduper den nye listen fra Autocomplete:
      const deduped = Array.from(new Set(newValue));

      if (context === 'TICKET') {
        // === Endring i Ticket ===
        const oldTicketTo: string[] = state.ticket.toEmailList || [];
        const oldTicketCc: string[] = state.ticket.ccEmailList || [];

        let updatedTo: string[] = oldTicketTo;
        let updatedCc: string[] = oldTicketCc;

        // Sett opp lokale variabler for gjeldende TicketPost (før oppdatering):
        const oldPostTo: string[] =
          state.ticketPost.ticketPost.toEmailList || [];
        const oldPostCc: string[] =
          state.ticketPost.ticketPost.ccEmailList || [];

        if (field === 'TO') {
          // --- Brukeren har oppdatert Ticket.TO ---

          // Beregn hva som er lagt til og hva som er fjernet:
          updatedTo = deduped;
          const addedTo = updatedTo.filter(
            (email) => !oldTicketTo.includes(email)
          );
          const removedTo = oldTicketTo.filter(
            (email) => !updatedTo.includes(email)
          );

          // Fjern fra Ticket.CC alt som nå ligger i updatedTo (unngå duplikater TO→CC):
          updatedCc = oldTicketCc.filter((email) => !updatedTo.includes(email));

          // 1a) Dispatche oppdaterte Ticket-lister
          dispatch({ type: 'SET_TO_EMAILS', payload: updatedTo });
          dispatch({ type: 'SET_CC_EMAILS', payload: updatedCc });

          // === Synk nedover til TicketPost.TO ===
          //  - Fjern adresser som ble fjernet i Ticket.TO
          //  - Legg til nye adresser som ble lagt til i Ticket.TO
          let newPostTo = [...oldPostTo];

          if (addedTo.length > 0) {
            // Legg til nye TO-adresser i TicketPost.TO
            newPostTo = Array.from(new Set([...newPostTo, ...addedTo]));
          }
          if (removedTo.length > 0) {
            // Fjern de samme adresser som ble fjernet i Ticket.TO
            newPostTo = newPostTo.filter((email) => !removedTo.includes(email));
          }
          // === Fjern fra TicketPost.CC eventuelle adresser som nå ligger i newPostTo ===
          let newPostCc = oldPostCc.filter(
            (email) => !newPostTo.includes(email)
          );

          dispatch({ type: 'SET_POST_TO_EMAILS', payload: newPostTo });
          dispatch({ type: 'SET_POST_CC_EMAILS', payload: newPostCc });
        } else {
          // --- Brukeren har oppdatert Ticket.CC ---
          updatedCc = deduped.filter((email) => !oldTicketTo.includes(email));
          const removedCc = oldTicketCc.filter(
            (email) => !updatedCc.includes(email)
          );
          const addedCc = updatedCc.filter(
            (email) => !oldTicketCc.includes(email)
          );

          // Ticket.TO forblir intakt:
          updatedTo = oldTicketTo;

          // 2a) Dispatche oppdaterte Ticket-lister
          dispatch({ type: 'SET_CC_EMAILS', payload: updatedCc });
          dispatch({ type: 'SET_TO_EMAILS', payload: updatedTo });

          // === Synk nedover til TicketPost.CC ===
          // Fjern i TicketPost.CC de som ble fjernet i Ticket.CC
          let newPostCc = [...oldPostCc];

          if (addedCc.length > 0) {
            // Først: sørg for at ingen nye CC-adresser allerede ligger i TicketPost.TO
            const safeAddedCc = addedCc.filter(
              (email) => !oldPostTo.includes(email)
            );
            newPostCc = Array.from(new Set([...newPostCc, ...safeAddedCc]));
          }
          if (removedCc.length > 0) {
            newPostCc = newPostCc.filter((email) => !removedCc.includes(email));
          }

          // === Fjern fra TicketPost.TO eventuelle adresser som nå ligger i newPostCc ===
          let newPostTo = oldPostTo.filter(
            (email) => !newPostCc.includes(email)
          );

          dispatch({ type: 'SET_POST_CC_EMAILS', payload: newPostCc });
          dispatch({ type: 'SET_POST_TO_EMAILS', payload: newPostTo });
        }
        dispatch({ type: 'SET_IS_DIRTY', payload: true });
      } else {
        // === Endring i TicketPost alene: berører kun TicketPost, ikke Ticket ===
        const oldPostTo: string[] =
          state.ticketPost.ticketPost.toEmailList || [];
        const oldPostCc: string[] =
          state.ticketPost.ticketPost.ccEmailList || [];

        let updatedPostTo: string[] = oldPostTo;
        let updatedPostCc: string[] = oldPostCc;

        if (field === 'TO') {
          updatedPostTo = deduped;
          // Fjern fra TicketPost.CC alt som nå ligger i updatedPostTo
          updatedPostCc = oldPostCc.filter(
            (email) => !updatedPostTo.includes(email)
          );

          dispatch({ type: 'SET_POST_TO_EMAILS', payload: updatedPostTo });
          dispatch({ type: 'SET_POST_CC_EMAILS', payload: updatedPostCc });
          dispatch({ type: 'SET_IS_DIRTY', payload: true });
        } else {
          updatedPostCc = deduped.filter((email) => !oldPostTo.includes(email));
          updatedPostTo = oldPostTo.filter(
            (email) => !updatedPostCc.includes(email)
          );
          dispatch({ type: 'SET_POST_CC_EMAILS', payload: updatedPostCc });
          dispatch({ type: 'SET_POST_TO_EMAILS', payload: updatedPostTo });
          dispatch({ type: 'SET_IS_DIRTY', payload: true });
        }
        // NB! Vi gjør ingen dispatch til Ticket når konteksten er 'TICKETPOST'.
      }
    };
  // 2) Felles oppdatering av "rå inputValue" (toInput, ccInput, postToInput, postCcInput)
  const handleInputChange =
    (context: 'TICKET' | 'TICKETPOST', field: 'TO' | 'CC') =>
    (_event: React.SyntheticEvent, value: string) => {
      if (context === 'TICKET') {
        if (field === 'TO') setToInput(value);
        else setCcInput(value);
      } else {
        if (field === 'TO') setPostToInput(value);
        else setPostCcInput(value);
      }
    };
  // 3) Felles onBlur: Legg til siste e-post-chip hvis gyldig
  const handleInputBlur =
    (context: 'TICKET' | 'TICKETPOST', field: 'TO' | 'CC') => () => {
      let currentValue: string;
      let currentList: string[];

      if (context === 'TICKET') {
        if (field === 'TO') {
          currentValue = toInput.trim();
          // Fallback til tom array om state.ticket.toEmailList ikke er satt ennå
          currentList = state.ticket.toEmailList || [];
        } else {
          currentValue = ccInput.trim();
          currentList = state.ticket.ccEmailList || [];
        }
        dispatch({ type: 'SET_IS_TICKET_DIRTY', payload: true });
      } else {
        if (field === 'TO') {
          currentValue = postToInput.trim();
          // Fallback til tom array om state.ticketPost.toEmailList ikke er satt ennå
          currentList = state.ticketPost.ticketPost.toEmailList || [];
        } else {
          currentValue = postCcInput.trim();
          currentList = state.ticketPost.ticketPost.ccEmailList || [];
        }
        dispatch({ type: 'SET_IS_TICKET_POST_DIRTY', payload: true });
      }

      if (
        currentValue &&
        emailRegex.test(currentValue) &&
        !currentList.includes(currentValue)
      ) {
        handleEmailsChange(context, field)(null as any, [
          ...currentList,
          currentValue,
        ]);
      }

      // Nullstill inputValue‐feltet
      if (context === 'TICKET') {
        if (field === 'TO') setToInput('');
        else setCcInput('');
      } else {
        if (field === 'TO') setPostToInput('');
        else setPostCcInput('');
      }
    };
  // når en employee velges, legges epost til i To
  const handleChangeEmployee = (
    e: React.MouseEvent<HTMLElement>,
    employee: IEmployeeViewModel
  ) => {
    e.preventDefault();
    e.preventDefault();
    const email = employee.email.trim();

    if (email) {
      // Replace the entire array with just the new email
      dispatch({
        type: 'SET_TO_EMAILS',
        payload: [email],
      });
      dispatch({
        type: 'SET_POST_TO_EMAILS',
        payload: [email],
      });
    }

    console.log('setContact', employee);

    dispatch({
      type: 'SET_CONTACT',
      payload: employee,
    });

    // Oppdater kontakt og sett dirty-flag uansett
    dispatch({ type: 'SET_IS_TICKET_DIRTY', payload: true });
  };
  const handleFocus = (event: React.FocusEvent<HTMLInputElement>) => {
    event.target.select();
  };
  const handleAssigneMe = () => {
    putTicketResponsible.mutate({
      ticketId: state.ticketPost.ticket.id,
      responsibleId: user.id,
    });
    let ticket = _.cloneDeep(state.ticketPost.ticket);
    ticket.responsible = user;
    // Triggerer oppdatering av antall via atom toggle
    setIsQtyUpdate(true);
    dispatch({
      type: 'SET_TICKET',
      payload: ticket,
    });
  };
  const handleChangeResponsable = (e: any, employee: IEmployeeViewModel) => {
    e.preventDefault();
    // Triggerer oppdatering av antall via atom toggle
    setIsQtyUpdate(true);

    let ticketResponsible = {
      ticketId: state.ticketPost.ticket.id,
      responsibleId: employee.id,
    };
    putTicketResponsible.mutate(ticketResponsible);
    let ticket = _.cloneDeep(state.ticketPost.ticket);
    ticket.responsible = employee;
    dispatch({
      type: 'SET_TICKET',
      payload: ticket,
    });
  };
  const handleChangeWorkRole = (
    event: FormOrMouseEvent,
    selectedObject: any,
    objectType: EnumObjectType
  ) => {
    if (!state.ticketPost.isEditable) return;
    switch (objectType) {
      case EnumObjectType.WorkRole:
        let object = selectedObject as IWorkRoleViewModel;
        console.log('Selected work role:', object);
        dispatch({ type: 'SET_WORK_ROLE', payload: object });
        dispatch({ type: 'SET_IS_TICKET_POST_DIRTY', payload: true });
        break;
      default:
        break;
    }
  };
  const handleChangeSchedule = (changeType: string, e: any) => {
    let scheduleTime = _.cloneDeep(state.ticketPost.scheduleTime);
    switch (changeType.toUpperCase()) {
      case 'DELIVERY_DATE':
        scheduleTime.deliveryDate = e;
        // Check if the deliveryDate is a Monday
        if (dayjs(scheduleTime.deliveryDate).day() === 1) {
          // Day.js treats Sunday as 0, Monday as 1, and so on.
          // Set startDate to the previous Friday at 07:00
          const startDateDayjs = dayjs(scheduleTime.deliveryDate)
            .subtract(3, 'day')
            .set('hour', 7)
            .set('minute', 0);
          scheduleTime.startDate = startDateDayjs;
        }
        break;
      case 'SCHEDULED_DATE':
        scheduleTime.startDate = e;
        scheduleTime.scheduleType = EnumScheduleType.Reminder;
        break;
      case 'SCHEDULE_TYPE':
        scheduleTime.scheduleType = e;
        break;
      case 'HOURS':
        scheduleTime.estimatedTime.hours = e;
        break;
      case 'MINUTES':
        scheduleTime.estimatedTime.minutes = e;
        break;
    }

    dispatch({
      type: 'SET_SCHEDULE_TIME',
      payload: scheduleTime,
    });
    dispatch({ type: 'SET_IS_TICKET_POST_DIRTY', payload: true });
  };
  const handleSelectedPost = (ticketPost: ITicketPostViewModel) => {
    console.log('WORKROLE: SELECTED TICKETPOST: ', ticketPost);
    // console.log('...handleSelectedPost, state', state);

    if (!isListDisabled) {
      // Only update non-text fields, preserve the current edited text

      console.log('=== CLICK HANDLER START ===');
      console.log(
        'Current isDirty before click:',
        state.ticketPost.ticketPost.isDirty
      );
      console.log(
        'Current message before click:',
        state.ticketPost.ticketPost.message
      );
      console.log('Target ticket post message:', ticketPost.message);

      console.log('=== CLICK HANDLER END ===');

      dispatch({
        type: 'SELECT_TICKET_POST_PRESERVE_TEXT',
        payload: {
          ticketPost,
          preserveText: state.ticketPost.ticketPost.isDirty,
        },
      });
    }

    const startTime = dayjs(ticketPost.startTime);
    const endTime = dayjs(ticketPost.endTime);

    ticketPost.startTime = startTime;
    ticketPost.endTime = endTime;
    dispatch({
      type: 'SET_TICKET_POST',
      payload: ticketPost,
    });
    // 2) Parse ut toEmail‐strengen til en string‐array
    const toList: string[] = ticketPost.toEmail
      ? ticketPost.toEmail
          .split(';')
          .map((email: string) => email.trim())
          .filter((email: string) => email.length > 0)
      : [];
    // 3) Parse ut ccEmail‐strengen til en string‐array
    const ccList: string[] = ticketPost.ccEmail
      ? ticketPost.ccEmail
          .split(';')
          .map((email: string) => email.trim())
          .filter((email: string) => email.length > 0)
      : [];
    // 4) Dispatche opp TO‐listen
    /*  dispatch({
        type: 'SET_TO_EMAILS',
        payload: toList,
      });
      dispatch({
        type: 'SET_CC_EMAILS',
        payload: ccList,
      }); */
    // 6) Dispatche opp TO‐listen
    dispatch({
      type: 'SET_POST_TO_EMAILS',
      payload: toList,
    });

    // 7) Dispatche opp CC‐listen
    dispatch({
      type: 'SET_POST_CC_EMAILS',
      payload: ccList,
    });

    dispatch({
      type: 'UPDATE_TICKET_POST_BILLING',
    });

    dispatch({ type: 'SET_IS_TICKET_POST_DIRTY', payload: false });

    // check if SET_TICKET_POST_BILLING
    // calculate new ticketPostBilling
    // sertte new ticketPostBilling
    if (
      state.ticketPost.ticket.fixedHourlyRate === undefined ||
      state.ticketPost.ticket.fixedHourlyRate === null ||
      state.ticketPost.ticket.fixedHourlyRate === -1
    ) {
      if (ticketPost.workRole != null) {
        console.log('WORKROLE: ticketpost', ticketPost.workRole);
        dispatch({
          type: 'SET_WORK_ROLE',
          payload: ticketPost.workRole,
        });
      } else if (state.ticketPost.ticket.company.workRole != null) {
        console.log('WORKROLE: ticket', state.ticketPost.ticketPost.workRole);
        dispatch({
          type: 'SET_WORK_ROLE',
          payload: state.ticketPost.ticket.company.workRole,
        });
      } else if (user.workRole) {
        console.log('WORKROLE: use', state.ticketPost.ticketPost.workRole);
        dispatch({
          type: 'SET_WORK_ROLE',
          payload: user.workRole,
        });
      }
    }
    // check if isBilled
    dispatch({
      type: 'SET_IS_EDITABLE',
      payload: ticketPost.isBilled ? false : true,
    });
    // check if mail is sendt
    dispatch({
      type: 'SET_IS_EMAIL_ALLOWED',
      payload: true,
    });

    // disable dirty
    // dispatch({
    //   type: 'SET_IS_DIRTY',
    //   payload: false,
    // });

    // enable list
    

    const hour = dayjs(ticketPost.startTime).hour();
    const minute = dayjs(ticketPost.startTime).minute();
    checkForOvertime(state.ticketPost.rates, hour, minute);
  };
  const handleSwitchPage = (page: EnumSubButtonInterface) => {
    console.log('handleSwitchPage', page);
    switch (page) {
      case EnumSubButtonInterface.Details:
        dispatch({
          type: 'SET_PAGE',
          payload: page,
        });
        break;
      case EnumSubButtonInterface.Communication:
        dispatch({
          type: 'SET_PAGE',
          payload: page,
        });
        break;
      case EnumSubButtonInterface.Products:
        dispatch({
          type: 'SET_PAGE',
          payload: page,
        });
        break;
      case EnumSubButtonInterface.CheckList:
        dispatch({
          type: 'SET_PAGE',
          payload: page,
        });
        break;
      case EnumSubButtonInterface.NewPost:
        dispatch({
          type: 'SET_PAGE',
          payload: EnumSubButtonInterface.Communication,
        });
        dispatch({
          type: 'REMOVE_TICKET_POST',
          payload: state.ticketPost.ticketPost.id,
        });
        dispatch({
          type: 'SET_IS_EDITABLE',
          payload: true,
        });
        dispatch({
          type: 'SET_WORK_ROLE',
          payload: state.ticketPost.ticket.company.workRole,
        });
        break;
      default:
        break;
    }
  };
  const handleChangeCompany = (
    e: React.MouseEvent<HTMLElement>,
    company: ICompanyViewModel
  ) => {
    e.preventDefault();
    setIsObjectList(true);
    let employee: IEmployeeWithCompanyViewModel = {
      id: 'new',
      name: '',
      department: '',
      phone: '',
      email: '',
      budget: 0,
      title: '',
      url: '',
      workRole: null,
      company: {} as ICompanyViewModel,
      departmentAddress: {} as IAddressViewModel,
      companyAddress: company.mainAddress,
      homeOffice: company?.contact?.address || undefined || null,
    };

    console.log('handleChangeCompany xxx', company);

    let tmp: IDeliveryAddressViewModel[] = GenerateAddressList(
      state.ticket.addressList,
      owner,
      employee
    );

    handleChangeEmployee(
      e,
      company?.contact
        ? company.contact
        : (employee as unknown as IEmployeeViewModel)
    );

    dispatch({
      type: 'UPDATE_ADDRESS_LIST',
      payload: tmp,
    });
    dispatch({
      type: 'SET_TICKET_COMPANY',
      payload: company,
    });
    dispatch({
      type: 'SET_COMPANY',
      payload: company,
    });
    /*  dispatch({
      type: 'SET_CONTACT',
      payload: company?.contact,
    }); */
    dispatch({
      type: 'SET_EMPLOYEE',
      payload: company?.contact,
    });
    let workRole = GetWorkRole(
      company?.workRole ?? null,
      user.workRole,
      state.ticketPost.ticketPost.workRole
    );
    // console.log('GetWorkRole w', workRole);
    if (workRole) {
      dispatch({
        type: 'SET_WORK_ROLE',
        payload: workRole,
      });
    }
    dispatch({
      type: 'SET_IS_TICKET_DIRTY',
      payload: true,
    });
  };
  const updateStatus = (status: EnumOrderPostStatus, id?: string | null) => {
    // ge satus ickeproduc and change saus o he right id
    let payload = _.cloneDeep(state.products.ticketProducts);
    payload.forEach((element) => {
      if (element.id === id) {
        element.status = status;
      }
    });
    dispatch({
      type: 'SET_TICKET_PRODUCTS',
      payload: payload,
    });
  };

  const handlePriorityChange = (e: any, priority: EnumPriority) => {
    e.preventDefault();
    dispatch({ type: 'SET_PRIORITY', payload: priority });
    dispatch({
      type: 'SET_IS_TICKET_DIRTY',
      payload: true,
    });
  };
  const handleChangeAutoAnswer = (
    event: any,
    autoAnswer: IAutoAnswersViewModel
  ) => {
    console.log('handleChangeAutoAnswer', autoAnswer);
    dispatch({
      type: 'SET_AUTO_ANSWER',
      payload: autoAnswer,
    });
    dispatch({ type: 'SET_IS_TICKET_POST_DIRTY', payload: true });
  };
  const handleChangeCompanyProduct = (
    event: any,
    companyProduct: ICompanyProductViewModel
  ) => {
    dispatch({ type: 'SET_COMPANY_PRODUCT', payload: companyProduct });
    dispatch({
      type: 'SET_IS_DIRTY',
      payload: true,
    });
  };
  const handleChangeTitle = (e: any) => {
    dispatch({ type: 'EDIT_TITLE', payload: e.target.value });
    dispatch({
      type: 'SET_IS_TICKET_DIRTY',
      payload: true,
    });
  };
  const handleSetTime = (e: any, interval: number) => {
    e.preventDefault();
    dispatch({
      type: 'SET_END_DATE',
      payload: dayjs(state.ticketPost.ticketPost.endTime).add(
        interval,
        'minute'
      ),
    });
    dispatch({
      type: 'UPDATE_TICKET_POST_BILLING',
    });
    dispatch({ type: 'SET_IS_TICKET_POST_DIRTY', payload: true });
  };
  useEffect(() => {
    if (workRoleData) {
      dispatch({
        type: 'SET_WORK_ROLES',
        payload: workRoleData.workRoles,
      });
    }
  }, [workRoleData]);
  useEffect(() => {
    console.log('=== STATE UPDATED ===');
    console.log('Current message:', state.ticketPost.ticketPost.message);
    console.log('Current isDirty:', state.ticketPost.ticketPost.isDirty);
    console.log('Current ticketPost ID:', state.ticketPost.ticketPost.id);
  }, [
    state.ticketPost.ticketPost.message,
    state.ticketPost.ticketPost.isDirty,
    state.ticketPost.ticketPost.id,
  ]);
  useEffect(() => {
    // console.log('...selected documents', selectedDocuments);
    if (selectedDocuments.length > 0) {
      dispatch({
        type: 'CHANGE_ATTACHMENTS',
        payload: selectedDocuments,
      });
    }
  }, [selectedDocuments]);
  useEffect(() => {
    if (ratesData && ratesData.rates) {
      let rates = [...ratesData.rates];
      // console.log('ratesData', ratesData);
      // Example: Let's say you want to increase the rate by 10 for each rate
      rates = rates.map((rate: IRateViewModel) => {
        rate.rateValue = 0;
        return rate;
      });
      dispatch({
        type: 'SET_RATES',
        payload: rates,
      });
    }
  }, [ratesData]);
  useEffect(() => {
    if (ticketPostDataList) {
      console.log('ticketPostDataList', ticketPostDataList);
      dispatch({
        type: 'SET_TICKET_POSTS',
        payload: ticketPostDataList.ticketPosts,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ticketPostDataList]);
  // triggers on changes to state.ticketPost (the entire screen)
  useEffect(() => {
    if (state.ticketPost.rates && state.ticketPost.rates.length > 0) {
      console.log('XXX TICKETPOST : useeffact', state.ticketPost);
      if (
        state.ticketPost.ticket.fixedHourlyRate === undefined ||
        state.ticketPost.ticket.fixedHourlyRate === null
      ) {
        state.ticketPost.ticket.fixedHourlyRate = -1;
      }

      //check if overtime
      if (state.ticketPost.rates) {
        let isShowOverTime = checkForOvertime(
          state.ticketPost.rates,
          state.ticketPost.ticketPost.endTime.hour(),
          state.ticketPost.ticketPost.endTime.minute()
        );
        dispatch({
          type: 'SET_SHOW_OVERTIME',
          payload: isShowOverTime,
        });
        // console.log('economy - ');
        dispatch({
          type: 'SET_TOTAL_TIME',
          payload: CalculateTotalTime(
            state.ticketPost.ticketPost.startTime,
            state.ticketPost.ticketPost.endTime,
            null,
            null
          ) as string,
        });
      }
      // update tickeptostbilling
      dispatch({
        type: 'UPDATE_TICKET_POST_BILLING',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.ticketPost.ticketPost]);

  useEffect(() => {
    if (ticketData) {
      // 1) Send hele ticketData til SET_TICKET‐action
      console.log('TicketCommunications - ticketData', ticketData);
      dispatch({
        type: 'SET_TICKET',
        payload: ticketData,
      });

      // 2) Parse ut toEmail‐strengen til en string‐array
      const toList: string[] = ticketData.toEmail
        ? ticketData.toEmail
            .split(';')
            .map((email: string) => email.trim())
            .filter((email: string) => email.length > 0)
        : [];
      // 3) Parse ut ccEmail‐strengen til en string‐array
      const ccList: string[] = ticketData.ccEmail
        ? ticketData.ccEmail
            .split(';')
            .map((email: string) => email.trim())
            .filter((email: string) => email.length > 0)
        : [];
      // 4) Dispatche opp TO‐listen
      dispatch({
        type: 'SET_TO_EMAILS',
        payload: toList,
      });
      // 5) Dispatche opp CC‐listen
      dispatch({
        type: 'SET_CC_EMAILS',
        payload: ccList,
      });
      // 6) Dispatche opp TO‐listen
      dispatch({
        type: 'SET_POST_TO_EMAILS',
        payload: toList,
      });

      // 7) Dispatche opp CC‐listen
      dispatch({
        type: 'SET_POST_CC_EMAILS',
        payload: ccList,
      });

      // console.log('userAtom ticketData', user);
      let workRole = GetWorkRole(
        ticketData?.company?.workRole ?? null,
        user.workRole,
        state.ticketPost.ticketPost.workRole
      );
      // console.log('GetWorkRole w', workRole);
      if (workRole) {
        dispatch({
          type: 'SET_WORK_ROLE',
          payload: workRole,
        });
      }
    }
  }, [ticketData]);

  useEffect(() => {
    console.log('orderPostProducts changed', state.ticket.orderPostProducts);
  }, [state.ticket.orderPostProducts]);

  const onCommitToTicket = async (items: OrderPostProductViewModel[]) => {
    console.log('1. NEWTICKET: received items', items);
    // 1) Fjern null/undefined og entries uten gyldig product/id
    const cleanedItems = (items || []).filter((x) => {
      return x && x.id && x.id.trim() !== '';
    });

    // (valgfritt) Logg hvis noe ble filtrert bort:
    if (cleanedItems.length !== items.length) {
      console.warn('1. NEWTICKET: filtered out invalid items', {
        before: items.length,
        after: cleanedItems.length,
        items,
      });
    }

    // 2) Oppdater state med kun gyldige produkter
    dispatch({ type: 'SET_ORDER_POST_PRODUCTS', payload: cleanedItems });
    console.log('1. NEWTICKET: cleaned cleanedItems', cleanedItems);
    // 3) Bygg ny ticket basert på eksisterende state + rene produkter
    let newTicket = ConvertStateToTicketUpdateWithProductViewModel(
      state.ticket,
      user
    );

    newTicket = {
      ...newTicket,
      orderPostProducts: cleanedItems,
    };

    if (newTicket.status === EnumTicketStatus.AwaitingParts) {
      newTicket.status = EnumTicketStatus.InProgress;
    } else {
      newTicket.status = EnumTicketStatus.AwaitingParts;
    }

    console.log('1. NEWTICKET   onTicketSubmit =>', newTicket);

    putTicket.mutate(newTicket, {
      onSuccess: (res: any) => {
        console.log('1. NEWTICKET => res', res);
        if (res?.ticketProducts) {
          dispatch({
            type: 'SET_TICKET_PRODUCTS',
            payload: res.ticketProducts,
          });
        }
        dispatch({
          type: 'SET_IS_EDITABLE',
          payload: true,
        });
      },
    });
  };
  const onTicketPostSubmit = async () => {
    // console.log('onSubmit : state', state);
    let _state = _.cloneDeep(state.ticketPost);

    console.log('XXX TICKETPOST ID', _state.ticketPost.id);

    if (
      !isGuidEmpty(_state.ticketPost.id) &&
      isValidGuid(_state.ticketPost.id)
    ) {
      let ticketPost = ConvertToPutTicketPost(_state, state.ticket, user);
      if (selectedDocuments.length > 0) {
        ticketPost.attachments = ConvertToAttachment(selectedDocuments) ?? [];
      } else {
        ticketPost.attachments = [];
      }
      // check if orginaleMessage is empty
      if (
        _state.ticketPost.originalMessage === '' ||
        _state.ticketPost.originalMessage === null
      ) {
        ticketPost.originalMessage = _state.ticketPost.message;
      } else {
        ticketPost.originalMessage = _state.ticketPost.originalMessage;
      }
      console.log(
        'XXX TICKETPOST PUT',
        ticketPost,
        state.ticketPost.ticketPost.id
      );
      putTicketPost.mutate(ticketPost, {
        onSuccess: (res: any) => {
          console.log('putTicketPost', res);
          dispatch({
            type: 'REMOVE_TICKET_POST',
            payload: state.ticketPost.ticketPost.id,
          });
          dispatch({
            type: 'SET_IS_EDITABLE',
            payload: true,
          });
        },
      });
    } else {
      let ticketPost = ConvertToTicketPost(_state, state.ticket, user);

      console.log(
        'XXX TICKETPOST POST',
        ticketPost,
        state.ticketPost.ticketPost.id
      );
      postTicketPost.mutate(ticketPost, {
        onSuccess: (res: any) => {
          console.log('postTicketPost', res);
          dispatch({
            type: 'REMOVE_TICKET_POST',
            payload: res.id,
          });
          dispatch({
            type: 'SET_IS_EDITABLE',
            payload: true,
          });

          if (
            Number(EnumTicketStatus.Closed) === res.status ||
            EnumTicketStatus.Resolved === res.status
          ) {
            navigate(`/tickets`);
          }
        },
      });
    }
  };
  const onTicketSubmit = async () => {
    console.log('onTicketSubmit =>', { ticket: state.ticket, user: user });

    let newTicket = ConvertStateToTicketUpdateWithProductViewModel(
      state.ticket,
      user
    );
    console.log('onTicketSubmit =>', newTicket);
    putTicket.mutate(newTicket, {
      onSuccess: (res: any) => {
        console.log('NEWTICKET => res', res);
        dispatch({
          type: 'SET_IS_EDITABLE',
          payload: true,
        });
      },
    });
  };
  const TicketHeaderLinks = TicketHeaderButtonDetail()
    .filter((button) => button.type !== EnumSubButtonInterface.CheckList)
    .map((button) => ({
      ...button,
      name: t(button.name), // Localize the name here
    }));
  console.log('1. RERENDER TICKET DETAILS', state.products.ticketProducts);

  const attachments = state.ticketPost.ticketPost.attachments || [];

  return (
    <Grid
      container
      sx={{
        display: 'flex',
        flexDirection: 'row',
      }}
    >
      {/* LEFT SIDE */}
      <Grid
        item
        xs={5}
        sx={{
          pl: 0.5,
          pr: 0.5,
        }}
      >
        {/* LEFT HEADER */}
        <Paper
          variant='elevation3'
          sx={{
            p: 2,
            height: 64,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
          }}
        >
          {/* LEFT HEADER BUTTONS */}
          <ToggleButtonGroup
            sx={{
              width: '100%',
              ml: 0.5,
              mt: -0.3,
              p: 0,
            }}
            color='secondary'
            size='small'
            orientation='horizontal'
            // value={currentView}
            exclusive
            aria-label='text alignment'
          >
            {TicketHeaderLinks.map((obj: SubButtonInterface, index: number) => {
              //console.log('headerlink object', obj);
              return (
                <ToggleButton
                  key={index}
                  name={obj.name}
                  onClick={(e: any) => {
                    e.preventDefault();
                    handleSwitchPage(obj.type);
                  }}
                  // Link={obj.to}
                  sx={{
                    m: 0,
                    p: 0,
                    width: 225,
                    borderRadius: 2,
                    borderLeft: 2,
                    borderRight: 2,
                    fontSize: 14,
                    borderLeftColor: 'primary.light',
                    borderRightColor: 'primary.light',
                  }}
                  value={index}
                  aria-label='left aligned'
                >
                  {obj.icon && <obj.icon sx={{ mr: 1 }} />}
                  {obj.name}
                </ToggleButton>
              );
            })}
          </ToggleButtonGroup>
        </Paper>

        {/* LEFT SIDE DETAIL */}

        {state.ticketPost.page === EnumSubButtonInterface.Details && (
          <List
            sx={{
              p: 1,
              height: Math.ceil(height - 260),
              backgroundColor: 'primary.main',
              overflow: 'auto',
            }}
          >
            <Grid
              container
              sx={{
                m: 0,
                p: 0,
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <Grid
                item
                xs={12}
                sx={{
                  mb: 2,
                  backgroundColor: 'primary.main',
                }}
              >
                <FormBox
                  Icon={LocalActivityRoundedIcon}
                  title={t('ticket.status')}
                  FormBTN={
                    <Tooltip
                      title={
                        state.ticketPost.ticketPost?.isDirty
                          ? 'Kan ikke endre status: det finnes ulagrede endringer i kommunikasjonen'
                          : ''
                      }
                    >
                      <span>
                        <Select
                          size='small'
                          variant='standard'
                          value={state.ticket.status || EnumTicketStatus.New}
                          onChange={(e) => {
                            if (state.ticketPost.ticketPost?.isDirty) return;
                            dispatch({
                              type: 'SET_TICKET_STATUS',
                              payload: e.target.value,
                            });
                            dispatch({
                              type: 'SET_IS_TICKET_DIRTY',
                              payload: true,
                            });
                          }}
                          displayEmpty
                          sx={{ minWidth: 270 }}
                          disabled={state.ticketPost.ticketPost?.isDirty}
                        >
                          {ticketCommunicationStatus.map(
                            (item: ticketStatusInterface, index: number) => (
                              <MenuItem key={index} value={item.id}>
                                {item.name}
                              </MenuItem>
                            )
                          )}
                        </Select>
                      </span>
                    </Tooltip>
                  }
                />
              </Grid>
              {/* TICKET TITLE */}
              <Grid item xs={12} sx={{ mb: 4, pr: 1 }}>
                <TextField
                  name='name'
                  onFocus={handleFocus}
                  sx={{ ...ProductFormStyle.textField }}
                  label={
                    <Typography sx={{ ...ProductFormStyle.textFieldLabel }}>
                      {t('Ticket.TicketDetails.title')}
                    </Typography>
                  }
                  value={state.ticket.title}
                  onChange={(e) => handleChangeTitle(e)}
                />
              </Grid>

              {/* ======================= */}
              {/* TICKET: “TO” */}
              {/* ======================= */}
              <Grid item xs={12} sx={{ p: 0, pr: 1, mb: 4 }}>
                <Autocomplete
                  multiple
                  freeSolo
                  options={[]}
                  value={toTicketEmails}
                  inputValue={toInput}
                  onInputChange={handleInputChange('TICKET', 'TO')}
                  onChange={handleEmailsChange('TICKET', 'TO')}
                  renderTags={(value, getTagProps) =>
                    value.map((email, index) => {
                      const props = getTagProps({ index });
                      const valid = emailRegex.test(email);
                      return (
                        <Chip
                          {...props}
                          variant='outlined'
                          label={email}
                          color={valid ? 'default' : 'error'}
                          sx={
                            valid
                              ? {}
                              : {
                                  borderColor: 'error.main',
                                  color: 'error.main',
                                }
                          }
                        />
                      );
                    })
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant='standard'
                      label={t('Ticket.TicketDetails.ticketTypes.to')}
                      onFocus={(e) => e.target.select()}
                      onBlur={handleInputBlur('TICKET', 'TO')}
                      error={toInput !== '' && !emailRegex.test(toInput)}
                      helperText={
                        toInput !== '' && !emailRegex.test(toInput)
                          ? 'Ugyldig e-post'
                          : ''
                      }
                      sx={{
                        '& .MuiInputBase-root.Mui-focused .MuiInputBase-input':
                          {
                            backgroundColor: 'rgba(0,0,0,0.2)',
                          },
                      }}
                    />
                  )}
                  sx={{ width: '95%', mt: -2.5 }}
                />
              </Grid>
              {/* ======================= */}
              {/* TICKET: “CC” */}
              {/* ======================= */}
              <Grid item xs={12} sx={{ p: 0, pr: 1, mb: 2 }}>
                <Autocomplete
                  multiple
                  freeSolo
                  options={[]}
                  value={ccTicketEmails}
                  inputValue={ccInput}
                  onInputChange={handleInputChange('TICKET', 'CC')}
                  onChange={handleEmailsChange('TICKET', 'CC')}
                  renderTags={(value, getTagProps) =>
                    value.map((email, index) => {
                      const props = getTagProps({ index });
                      const valid = emailRegex.test(email);
                      return (
                        <Chip
                          {...props}
                          variant='outlined'
                          label={email}
                          color={valid ? 'default' : 'error'}
                          sx={
                            valid
                              ? {}
                              : {
                                  borderColor: 'error.main',
                                  color: 'error.main',
                                }
                          }
                        />
                      );
                    })
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant='standard'
                      label={t('Ticket.TicketDetails.ticketTypes.cc')}
                      onFocus={(e) => e.target.select()}
                      onBlur={handleInputBlur('TICKET', 'CC')}
                      error={ccInput !== '' && !emailRegex.test(ccInput)}
                      helperText={
                        ccInput !== '' && !emailRegex.test(ccInput)
                          ? 'Ugyldig e-post'
                          : ''
                      }
                      sx={{
                        '& .MuiInputBase-root.Mui-focused .MuiInputBase-input':
                          {
                            backgroundColor: 'rgba(0,0,0,0.2)',
                          },
                      }}
                    />
                  )}
                  sx={{ width: '95%', mt: -2.5 }}
                />
              </Grid>

              {/* ASSIGN CUSTOMER EMPLOYEE HEADER */}
              <Grid item xs={12} sx={{ p: 0, mb: 2 }}>
                <FormBox
                  Icon={PersonSearchRoundedIcon}
                  title={t('Ticket.TicketDetails.assignCustomerEmployee')}
                />
              </Grid>
              {/* ASSIGN CUSTOMER EMPLOYEE */}
              <Grid item xs={6} sx={{ p: 0, mb: 2, position: 'relative' }}>
                {state.ticket.company ? (
                  <Stack direction='column'>
                    <SingleTicketCompanyView company={state.ticket.company} />
                    <Grid
                      item
                      sx={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        /*  pointerEvents: hasNonInternalMessages ? 'none' : 'auto',
                        opacity: hasNonInternalMessages ? 0.5 : 1, */
                      }}
                    >
                      <CompaniesDrawer
                        buttonContext={t('Ticket.TicketDetails.selectCompany')}
                        buttonIcon={<ChangeCircleIcon sx={{ fontSize: 26 }} />}
                        handleChange={handleChangeCompany}
                        isHideCompanyView={true}
                        isHideCompanyNavigation={true}
                      />
                    </Grid>
                  </Stack>
                ) : (
                  <CompaniesDrawer
                    buttonContext={t('Ticket.TicketDetails.selectCompany')}
                    buttonIcon={<ChangeCircleIcon sx={{ fontSize: 26 }} />}
                    handleChange={handleChangeCompany}
                    isHideCompanyView={true}
                    isHideCompanyNavigation={true}
                  />
                )}
              </Grid>
              <Grid item xs={6} sx={{ p: 0, mb: 2, position: 'relative' }}>
                {state?.ticket.contact?.id !== '' ? (
                  <Stack direction='column'>
                    <SingleTicketEmployeeView
                      employee={state.ticket.contact}
                      priority={state.ticket.priority}
                    />
                    <Grid
                      item
                      sx={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                      }}
                    >
                      <EmployeeDrawer
                        buttonContext={t('Ticket.TicketDetails.selectEmployee')}
                        buttonIcon={<ChangeCircleIcon sx={{ fontSize: 26 }} />}
                        handleChange={handleChangeEmployee}
                        companyId={state.ticket.company?.id}
                      />
                    </Grid>
                  </Stack>
                ) : (
                  <EmployeeDrawer
                    buttonContext={t('Ticket.TicketDetails.selectEmployee')}
                    buttonIcon={<ChangeCircleIcon sx={{ fontSize: 26 }} />}
                    handleChange={handleChangeEmployee}
                    companyId={state.ticket.company?.id}
                  />
                )}
              </Grid>

              {/* PRIORITY HEADER */}
              <Grid item xs={12} sx={{ p: 0, mb: 2, mt: 2 }}>
                <FormBox
                  Icon={PriorityHighRoundedIcon}
                  title={t('Ticket.TicketDetails.priority')}
                />
              </Grid>
              {/* PRIORITY BUTTONS  */}
              <Grid
                item
                xs={12}
                sx={{
                  p: 0,
                  mb: 2,
                  flexGrow: 1,
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}
              >
                <ButtonGroup
                  variant='contained'
                  aria-label='outlined primary button group'
                  size='small'
                  sx={{ width: '100%' }}
                >
                  <Button
                    key='NONE'
                    sx={{
                      width: '20%',
                      fontSize: 14,
                      backgroundColor:
                        state.ticket.priority === EnumPriority.NONE
                          ? GetPriorityColor(state.ticket.priority)
                          : 'primary.back',
                      '&:hover': {
                        backgroundColor: GetPriorityColor(EnumPriority.NONE),
                      },
                    }}
                    onClick={(e) => {
                      handlePriorityChange(e, 0);
                    }}
                  >
                    {t('Ticket.TicketDetails.priorityLevels.none')}
                  </Button>
                  <Button
                    key='LOW'
                    sx={{
                      width: '20%',
                      fontSize: 14,
                      backgroundColor:
                        state.ticket.priority === EnumPriority.LOW
                          ? GetPriorityColor(state.ticket.priority)
                          : 'primary.back',
                      '&:hover': {
                        backgroundColor: GetPriorityColor(EnumPriority.LOW),
                      },
                    }}
                    onClick={(e) => {
                      handlePriorityChange(e, 1);
                    }}
                  >
                    {t('Ticket.TicketDetails.priorityLevels.low')}
                  </Button>
                  <Button
                    key='NORMAL'
                    sx={{
                      width: '20%',
                      fontSize: 14,
                      backgroundColor:
                        state.ticket.priority === EnumPriority.NORMAL
                          ? GetPriorityColor(state.ticket.priority)
                          : 'primary.back',
                      '&:hover': {
                        backgroundColor: GetPriorityColor(EnumPriority.NORMAL),
                      },
                    }}
                    onClick={(e) => {
                      handlePriorityChange(e, 2);
                    }}
                  >
                    {t('Ticket.TicketDetails.priorityLevels.normal')}
                  </Button>
                  <Button
                    key='HIGH'
                    sx={{
                      width: '20%',
                      fontSize: 14,
                      backgroundColor:
                        state.ticket.priority === EnumPriority.HIGH
                          ? GetPriorityColor(state.ticket.priority)
                          : 'primary.back',
                      '&:hover': {
                        backgroundColor: GetPriorityColor(EnumPriority.HIGH),
                      },
                    }}
                    onClick={(e) => {
                      handlePriorityChange(e, 3);
                    }}
                  >
                    {t('Ticket.TicketDetails.priorityLevels.high')}
                  </Button>
                  <Button
                    key='CRITICAL'
                    sx={{
                      width: '20%',
                      fontSize: 14,
                      backgroundColor:
                        state.ticket.priority === EnumPriority.CRITICAL
                          ? GetPriorityColor(state.ticket.priority)
                          : 'primary.back',
                      '&:hover': {
                        backgroundColor: GetPriorityColor(
                          EnumPriority.CRITICAL
                        ),
                      },
                    }}
                    onClick={(e) => {
                      handlePriorityChange(e, 4);
                    }}
                  >
                    {t('Ticket.TicketDetails.priorityLevels.critical')}
                  </Button>
                </ButtonGroup>
              </Grid>
              {/* ISSUE HEADER */}
              <Grid item xs={12} sx={{ p: 0, pr: 1, mb: 2 }}>
                <FormBox
                  Icon={DevicesOtherRoundedIcon}
                  title={t('Ticket.TicketDetails.ticketDescription')}
                />
              </Grid>
              {/* ISSUE TYPE */}
              <Grid item xs={5} sx={{ m: 0, pr: 1, mb: -1 }}>
                {!state?.ticket.supportType ? (
                  <>
                    <ObjectDrawer
                      buttonContext={t('Ticket.TicketDetails.selectIssueType')}
                      buttonIcon={null}
                      objectList={!!objectDrawerList ? objectDrawerList : []}
                      objectType={[EnumObjectType.IssueType]}
                      handleChange={handleChangeAutoAnswer}
                      buttonHeight={80}
                      buttonWidth={'100%'}
                    />
                  </>
                ) : (
                  <>
                    {state.ticket.supportType && (
                      <SingleAutoAnswerView
                        autoAnswer={state.ticket.supportType}
                      />
                    )}
                    <Grid
                      item
                      sx={{
                        position: 'relative',
                        bottom: 78,
                        right: 4,
                        display: 'flex',
                        justifyContent: 'flex-end',
                      }}
                    >
                      <ObjectDrawer
                        buttonContext={t(
                          'Ticket.TicketDetails.selectIssueType'
                        )}
                        buttonIcon={<ChangeCircleIcon sx={{ fontSize: 26 }} />}
                        objectList={!!objectDrawerList ? objectDrawerList : []}
                        objectType={[EnumObjectType.IssueType]}
                        handleChange={handleChangeAutoAnswer}
                        buttonHeight={30}
                        buttonWidth={30}
                      />
                    </Grid>
                  </>
                )}
              </Grid>
              {/* ISSUE PRODUCT */}
              <Grid item xs={7} sx={{ m: 0, pl: 1, mb: -1 }}>
                {state.ticket.companyProductWithError ? (
                  <>
                    <SingleTicketContactProduct
                      product={state.ticket.companyProductWithError}
                    />
                    <Grid
                      item
                      sx={{
                        position: 'relative',
                        bottom: 78,
                        right: 8,
                        display: 'flex',
                        justifyContent: 'flex-end',
                      }}
                    >
                      <ObjectDrawer
                        buttonContext={t(
                          'Ticket.TicketDetails.selectCompanyProduct'
                        )}
                        buttonIcon={
                          <ChangeCircleIcon sx={{ fontSize: 26, m: 1.5 }} />
                        }
                        objectList={!!objectDrawerList ? objectDrawerList : []}
                        objectType={[EnumObjectType.EmployeeProducts]}
                        handleChange={handleChangeCompanyProduct}
                        buttonHeight={30}
                        buttonWidth={30}
                      />
                    </Grid>
                  </>
                ) : (
                  state.ticket.companyProducts &&
                  state.ticket.companyProducts.length > 0 && (
                    <ObjectDrawer
                      buttonContext={t(
                        'Ticket.TicketDetails.selectCompanyProduct'
                      )}
                      buttonIcon={null}
                      objectList={!!objectDrawerList ? objectDrawerList : []}
                      objectType={[EnumObjectType.EmployeeProducts]}
                      handleChange={handleChangeCompanyProduct}
                      buttonHeight={80}
                      buttonWidth={'100%'}
                    />
                  )
                )}
              </Grid>

              {/* JOBTYPE HEADER */}
              <Grid item xs={12} sx={{ p: 0, pr: 1, mb: 1 }}>
                <FormBox Icon={DevicesOtherRoundedIcon} title={'Job Type'} />
              </Grid>
              {/* JOB TYPE */}
              <Grid item xs={3} sx={{ pr: 2 }}>
                <Select
                  sx={{ width: '100%', p: 0, mt: -0.5 }}
                  labelId='JobType'
                  id='JobType'
                  variant='standard'
                  value={state.ticket.jobType}
                  label='Job Type'
                  onChange={(e) => {
                    dispatch({ type: 'SET_JOB_TYPE', payload: e.target.value });
                  }}
                >
                  <MenuItem value={0}>None</MenuItem>
                  <MenuItem value={1}>Support</MenuItem>
                  <MenuItem value={2}>OnBoarding</MenuItem>
                  <MenuItem value={3}>OffBoarding</MenuItem>
                  <MenuItem value={4}>ReplaceProduct</MenuItem>
                  <MenuItem value={5}>AssignProduct</MenuItem>
                  <MenuItem value={6}>NewProduct</MenuItem>
                  <MenuItem value={7}>Service</MenuItem>
                </Select>
              </Grid>

              {/* END  */}
            </Grid>
          </List>
        )}
        {/* LEFT SIDE COMMUNICATION */}
        {state.ticketPost.page === EnumSubButtonInterface.Communication && (
          <List
            sx={{
              p: 1,
              height: Math.ceil(height - 260),
              backgroundColor: isListDisabled ? 'primary.dark' : 'primary.back',
              overflow: 'auto',
            }}
          >
            {!!state.ticketPost.ticketPosts &&
              state.ticketPost.ticketPosts?.map(
                (ticketPost: ITicketPostViewModel, index: number) => (
                  <Grid
                    sx={{
                      border: 0,
                      boxShadow: 'none',
                    }}
                    key={index}
                    onClick={() => {
                      if (!isListDisabled) {
                        handleSelectedPost(ticketPost);
                      }
                    }}
                  >
                    <SingleMessage 
                      ticketPost={ticketPost} 
                      />
                  </Grid>
                )
              )}
          </List>
        )}
        {/* LEFT SIDE PRODUCTS */}
        {state.ticketPost.page === EnumSubButtonInterface.Products && (
          <List
            sx={{
              p: 1,
              height: Math.ceil(height - 260),
              backgroundColor: 'primary.back',
              overflow: 'auto',
            }}
          >
            {/* New Investment products */}
            <Grid
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                backgroundColor: 'rgba(0,0,0,0.2)',
                border: 1,
                borderColor: 'primary.main',
                borderRadius: 3,
                boxShadow: 3,
                letterSpacing: 3,
                fontSize: 16,
                p: 1,
              }}
            >
              <Typography
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  letterSpacing: 3,
                  fontSize: 16,
                }}
              >
                {t('ticketProductDrawer.orderedProducts').toUpperCase()}
              </Typography>
              <TicketProductDrawer
                open={false}
                onOpenChange={() => {}}
                onCommitToTicket={onCommitToTicket}
                companyId={state.ticket.company?.id || ''}
                ticketId={state.ticket.id || ''}
              />
            </Grid>
            {state.ticketPost.page === EnumSubButtonInterface.Products &&
              state.products.ticketProducts &&
              state.products.ticketProducts.length > 0 &&
              state.products.ticketProducts.map(
                (product: TicketProductViewInterface, index: number) => (
                  <SingleTicketProductView
                    key={index}
                    product={product}
                    companyId={state.ticket.companyId}
                    purchaserId={''}
                    updateStatus={updateStatus}
                  />
                )
              )}
            <Typography
              sx={{
                width: '100%',
                display: 'flex',
                height: 25,
                p: 1,
              }}
            ></Typography>

            {/* Consumables */}
            <Grid
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                backgroundColor: 'rgba(0,0,0,0.2)',
                border: 1,
                borderColor: 'primary.main',
                borderRadius: 3,
                boxShadow: 3,
                letterSpacing: 3,
                fontSize: 16,
                p: 1,
              }}
            >
              <Typography
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  letterSpacing: 3,
                  fontSize: 16,
                }}
              >
                {t('Products.ProductForm.consumable').toUpperCase()}
              </Typography>
              <ProductDrawer
                ticketId={state.ticket.id}
                ticketProductVariant={EnumProductVariant.Consumable}
              />
            </Grid>

            {state.ticketPost.page === EnumSubButtonInterface.Products &&
              state.products.consumableProducts &&
              state.products.consumableProducts.length > 0 &&
              state.products.consumableProducts.map(
                (product: IProductViewModel, index: number) => (
                  <SingleProductView key={index} product={product} />
                )
              )}
            <Typography
              sx={{
                width: '100%',
                display: 'flex',
                height: 25,
                p: 1,
              }}
            ></Typography>
            {/* Agreements */}
            {/*          <Grid
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                backgroundColor: 'rgba(0,0,0,0.2)',
                border: 1,
                borderColor: 'primary.main',
                borderRadius: 3,
                boxShadow: 3,
                letterSpacing: 3,
                fontSize: 16,
                p: 1,
              }}
            >
              <Typography
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  letterSpacing: 3,
                  fontSize: 16,
                }}
              >
                {t('ticketProductDrawer.agreementProduct').toUpperCase()}
              </Typography>
              <ProductDrawer
                ticketId={state.ticket.id}
                ticketProductVariant={EnumProductVariant.Agreement}
              />
            </Grid>

            {state.ticketPost.page === EnumSubButtonInterface.Products &&
              state.products.agreementProducts &&
              state.products.agreementProducts.length > 0 &&
              state.products.agreementProducts.map(
                (product: ICompanyProductViewModel, index: number) => (
                  <SingleCompanyProductView
                    key={index}
                    companyProduct={product}
                    quantity={product.quantity}
                  />
                )
              )}
            <Typography
              sx={{
                width: '100%',
                display: 'flex',
                height: 25,
                p: 1,
              }}
            ></Typography> */}
            {/* Company products */}
            {/*  <Grid
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                backgroundColor: 'rgba(0,0,0,0.2)',
                border: 1,
                borderColor: 'primary.main',
                borderRadius: 3,
                boxShadow: 3,
                letterSpacing: 3,
                fontSize: 16,
                p: 1,
              }}
            >
              <Typography
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  letterSpacing: 3,
                  fontSize: 16,
                }}
              >
                {t('ticketProductDrawer.investmentProduct').toUpperCase()}
              </Typography>
              <InvestmentProductDrawer
                open={false}
                onOpenChange={() => {}}
                onCommitToTicket={onCommitToTicket}
                companyId={state.ticket.company?.id || ''}
                ticketId={state.ticket.id || ''}
              />
            </Grid>
            {state.ticketPost.page === EnumSubButtonInterface.Products &&
              state.products.investmentProducts &&
              state.products.investmentProducts.length > 0 &&
              state.products.investmentProducts.map(
                (product: IProductViewModel, index: number) => (
                  <SingleProductView key={index} product={product} />
                )
              )}
            <Typography
              sx={{
                width: '100%',
                display: 'flex',
                height: 25,
                p: 1,
              }}
            ></Typography> */}

            {/* Service products */}
            {/*  <Grid
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                backgroundColor: 'rgba(0,0,0,0.2)',
                border: 1,
                borderColor: 'primary.main',
                borderRadius: 3,
                boxShadow: 3,
                letterSpacing: 3,
                fontSize: 16,
                p: 1,
              }}
            >
              <Typography
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  letterSpacing: 3,
                  fontSize: 16,
                }}
              >
                {t('ticketProductDrawer.serviceProduct').toUpperCase()}
              </Typography>
              <ServiceProductDrawer ticketId={state.ticket.id} />
            </Grid>
            {state.ticketPost.page === EnumSubButtonInterface.Products &&
              state.products.serviceProducts &&
              state.products.serviceProducts.length > 0 &&
              state.products.serviceProducts.map(
                (companyProduct: ICompanyProductViewModel, index: number) => (
                  <SingleCompanyProductView
                    key={index}
                    companyProduct={companyProduct}
                    quantity={companyProduct.quantity}
                  />
                )
              )}
            <Typography
              sx={{
                width: '100%',
                display: 'flex',
                height: 25,
                p: 1,
              }}
            ></Typography> */}
          </List>
        )}

        {/* LEFT SIDE CHECKLIST (removed) */}
        {/* LEFT SIDE NEW TICKET */}
        {state.ticketPost.page === EnumSubButtonInterface.NewTicket && (
          <List
            sx={{
              p: 1,
              height: Math.ceil(height - 256),
              backgroundColor: 'primary.back',
              overflow: 'auto',
            }}
          >
            New Ticket
          </List>
        )}
        {/* LEFT SIDE FOOTER */}
        <Paper
          variant='elevation3'
          sx={{
            p: 1,
            height: 64,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
          }}
        >
          <Stack direction={'column'} sx={{ mb: 1, pr: 1 }}>
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'right',
              }}
            >
              {state.ticketPost.page === EnumSubButtonInterface.Details && (
                <Button
                  disabled={!state.ticket.isDirty}
                  sx={{
                    width: '50%',
                    // backgroundColor: 'secondary.main',
                  }}
                  type='submit'
                  onClick={(e: any) => {
                    e.preventDefault();
                    onTicketSubmit();
                    dispatch({
                      type: 'SET_IS_EDITABLE',
                      payload: false,
                    });
                  }}
                  id={
                    !state.ticket.id
                      ? `${t('Ticket.TicketCommunications.submit')}`
                      : `${t('Ticket.TicketCommunications.confirmEdit')}`
                  }
                  variant='contained'
                >
                  {!state.ticket.id
                    ? `${t('Ticket.TicketCommunications.submit')}`
                    : `${t('Ticket.TicketCommunications.confirmEdit')}`}
                </Button>
              )}
            </Box>
          </Stack>
        </Paper>
      </Grid>

      {/* RIGHT SIDE */}
      <Grid
        item
        xs={7}
        sx={{
          pl: 0.5,
          pr: 0.5,
        }}
      >
        <Grid
          container
          sx={{
            p: 2,
            borderRadius: 2,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            display: 'flex',
            flexDirection: 'row',
            backgroundColor: 'primary.main',
          }}
        >
          <Button
            sx={{
              width: 128,
              height: 38,
              backgroundColor: 'rgba(0,0,0,0.2)',
              borderRadius: 1,
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.2)',
              },
            }}
            onClick={(e) => {
              e.preventDefault();
              handleSwitchPage(EnumSubButtonInterface.NewPost);
            }}
          >
            <Typography
              sx={{
                ...ProductFormStyle.SubHeader,
                ...{
                  pl: 1,
                  color: 'primary.text',
                },
              }}
            >
              {t('Ticket.TicketStyleConfig.newPost')}
            </Typography>
          </Button>

          {/* TICKET TITLE */}
          <Grid item sx={{ flexGrow: 1 }}>
            <Tooltip title={state.ticket.title} placement='top' arrow>
              <Typography
                sx={{
                  ...ProductFormStyle.SubHeader,
                  ...{
                    pl: 2,
                    fontSize: '18px',
                    mb: 1,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    maxWidth: '70%',
                  },
                }}
              >
                {state.ticket.title}
              </Typography>
            </Tooltip>
          </Grid>
          {/* TICKET NO */}
          <Grid item sx={{}}>
            <Typography
              sx={{
                ...ProductFormStyle.SubHeader,
                ...{
                  pl: 2,
                  fontSize: '18px',
                  mb: 1,
                  pr: 2,
                  letterSpacing: 2,
                  color: 'info.text',
                },
              }}
            >
              {state.ticketPost.ticket.ticketNo}
            </Typography>
          </Grid>
          <List
            sx={{
              height: Math.ceil(height - 242),
              width: '100%',
              mb: 0,
              p: 2,
              backgroundColor: 'primary.main',
              overflow: 'auto',
            }}
          >
            <Grid container key={'container'} sx={{}}>
              <Stack direction={'column'} key='stack' flex={1} sx={{}}>
                <Grid
                  container
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    mb: 1,
                  }}
                >
                  {/* RESPONISBLE */}
                  <Grid item xs={7} sx={{ m: 0, p: 0, mb: 0 }}>
                    <Grid
                      container
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                      }}
                    >
                      <Grid item xs={7} sx={{ m: 0, p: 0, mb: 1 }}>
                        {state.ticketPost.ticket?.responsible ? (
                          <Grid
                            item
                            xs={12}
                            sx={{ p: 0, mb: 0.5, position: 'relative' }}
                          >
                            <SingleTicketEmployeeView
                              employee={state.ticketPost.ticket.responsible}
                              priority={0}
                            />
                            <Grid
                              item
                              sx={{
                                position: 'absolute',
                                top: 0,
                                right: 3,
                              }}
                            >
                              <ObjectDrawer
                                buttonContext={t(
                                  'Ticket.TicketDetails.selectEmployee'
                                )}
                                buttonIcon={
                                  <ChangeCircleIcon sx={{ fontSize: 26 }} />
                                }
                                objectList={
                                  !!objectDrawerList ? objectDrawerList : []
                                }
                                objectType={[EnumObjectType.AppOwnerEmployees]}
                                handleChange={handleChangeResponsable}
                                buttonHeight={30}
                                buttonWidth={30}
                              />
                            </Grid>
                          </Grid>
                        ) : (
                          <Box sx={[boxStyle.base, { height: 60 }]}>
                            <Button
                              sx={{
                                mx: 'auto',
                                width: '100%',
                                height: '100%',
                                borderRadius: 3,
                              }}
                              variant='contained'
                              onClick={(e) => {
                                handleAssigneMe();
                              }}
                            >
                              <Typography sx={[TextStyle.text, {}]}>
                                {t(
                                  'Ticket.TicketCommunications.assignCustomerEmployee'
                                )}
                              </Typography>
                            </Button>
                            <Grid
                              item
                              sx={{
                                position: 'relative',
                                top: 0,
                                right: 3,
                              }}
                            >
                              <ObjectDrawer
                                buttonContext={t(
                                  'Ticket.TicketDetails.selectEmployee'
                                )}
                                buttonIcon={
                                  <ChangeCircleIcon sx={{ fontSize: 26 }} />
                                }
                                objectList={
                                  !!objectDrawerList ? objectDrawerList : []
                                }
                                objectType={[EnumObjectType.AppOwnerEmployees]}
                                handleChange={handleChangeResponsable}
                                buttonHeight={30}
                                buttonWidth={30}
                              />
                            </Grid>
                          </Box>
                        )}
                      </Grid>
                      <Grid item xs={5} sx={{ m: 0, pl: 1, mb: 1 }}>
                        {state.ticketPost.ticket.fixedHourlyRate > -1 ? (
                          <Grid sx={[gridStyle.base, { height: 60 }]}>
                            <Typography sx={[TextStyle.textCenter, {}]}>
                              {t('Ticket.TicketCommunications.fixedHourlyRate')}
                            </Typography>
                            <Typography
                              sx={[
                                TextStyle.textCenter,
                                {
                                  pt: 1,
                                  fontSize: 20,
                                  color: 'secondary.text',
                                },
                              ]}
                            >
                              {state.ticketPost.ticket.fixedHourlyRate.toFixed(
                                2
                              )}
                            </Typography>
                          </Grid>
                        ) : state.ticketPost.ticketPost?.workRole?.id ? (
                          <Grid sx={[gridStyle.base, { height: 60 }]}>
                            <Stack
                              direction='row'
                              spacing={0}
                              justifyContent={'space-between'}
                            >
                              {state.ticketPost.ticketPost?.workRole ? (
                                <Typography
                                  sx={[
                                    TextStyle.infoCenter,
                                    {
                                      pt: 0.5,
                                      fontSize: 12,
                                      letterSpacing: 2,
                                      color: 'primary.text',
                                    },
                                  ]}
                                >
                                  {t('Ticket.TicketCommunications.support')}
                                </Typography>
                              ) : (
                                <Typography
                                  sx={[
                                    TextStyle.infoCenter,
                                    {
                                      pt: 0.5,
                                      fontSize: 12,
                                      color: 'primary.text',
                                    },
                                  ]}
                                >
                                  {state.ticketPost.ticketPost?.workRole?.title}
                                </Typography>
                              )}

                              <ObjectDrawer
                                buttonContext={t(
                                  'Ticket.TicketCommunications.selectWorkRole'
                                )}
                                buttonIcon={<ChangeCircleIcon />}
                                objectList={
                                  !!objectDrawerList ? objectDrawerList : []
                                }
                                objectType={[EnumObjectType.WorkRole]}
                                handleChange={handleChangeWorkRole}
                                buttonHeight={30}
                                buttonWidth={30}
                              />
                            </Stack>

                            {state.ticketPost.ticketPost.isInHouse ? (
                              <Typography
                                sx={[
                                  TextStyle.textCenter,
                                  {
                                    pt: 0,
                                    fontSize: 18,
                                    color: 'secondary.text',
                                  },
                                ]}
                              >
                                {state.ticketPost.ticketPost?.workRole?.inHouseHourlyRate.toFixed(
                                  2
                                )}
                              </Typography>
                            ) : (
                              <Typography
                                sx={[
                                  TextStyle.textCenter,
                                  {
                                    pt: 0,
                                    fontSize: 18,
                                    color: 'secondary.text',
                                  },
                                ]}
                              >
                                {state.ticketPost.ticketPost?.workRole?.onSiteHourlyRate.toFixed(
                                  2
                                )}
                              </Typography>
                            )}
                          </Grid>
                        ) : (
                          <ObjectDrawer
                            buttonContext={t(
                              'Ticket.TicketCommunications.selectWorkRole'
                            )}
                            buttonIcon={null}
                            objectList={
                              !!objectDrawerList ? objectDrawerList : []
                            }
                            objectType={[EnumObjectType.WorkRole]}
                            handleChange={handleChangeWorkRole}
                            buttonHeight={60}
                            buttonWidth={'100%'}
                          />
                        )}
                      </Grid>
                      <Grid item xs={4} sx={{ pr: 0.5 }}>
                        <SwitchType
                          isChecked={
                            state.ticket.fixedHourlyRate === 0
                              ? false
                              : state.ticketPost.ticketPost.isBillable
                          }
                          dispatch={dispatch}
                          type={'SET_BILLABLE'}
                          header={t('Ticket.TicketCommunications.Billable')}
                          showNotification={false}
                          disabled={
                            state.ticketPost.ticketPost.internal ||
                            !state.ticketPost.isEditable ||
                            state.ticket.fixedHourlyRate === 0
                          }
                        />
                      </Grid>
                      <Grid item xs={4} sx={{ pl: 0.5 }}>
                        <SwitchType
                          isChecked={state.ticketPost.ticketPost.isOvertime}
                          dispatch={dispatch}
                          type={'SET_OVERTIME'}
                          header={t('Ticket.TicketCommunications.overtime')}
                          showNotification={state.ticketPost.isShowOverTime}
                          disabled={false || !state.ticketPost.isEditable}
                        />
                      </Grid>
                      <Grid item xs={4} sx={{ m: 0, pl: 1 }}>
                        <SwitchType
                          isChecked={state.ticketPost.ticketPost.isInHouse}
                          dispatch={dispatch}
                          type={'SET_IS_IN_HOUSE'}
                          header={t('Ticket.TicketCommunications.inHouse')}
                          showNotification={false}
                          disabled={false || !state.ticketPost.isEditable}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  {/* BILLABLE TIME BUTTONS */}
                  <Grid
                    item
                    xs={5}
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                    }}
                  >
                    <Grid container sx={{ m: 0, pl: 1 }}>
                      <Grid
                        item
                        xs={12}
                        sx={{
                          m: 0,
                          p: 0,
                          pl: 1,
                          pr: 1,
                          mt: 0,
                          backgroundColor: 'rgba(0, 0, 0, 0.1)',
                          borderRadius: 2,
                          height: 60,
                        }}
                      >
                        <Stack direction='row' spacing={0} flexGrow={1}>
                          <Typography sx={[TextStyle.label, { width: '60%' }]}>
                            {t('Ticket.TicketCommunications.dateTime')}
                          </Typography>
                          <Typography
                            sx={[TextStyle.value, { pr: 2, pt: 0.5 }]}
                          >
                            {state.ticketPost.totalTime}
                          </Typography>
                          {state.ticketPost.isTotalTimeOpen ? (
                            <IconButton
                              sx={{ m: 0, p: 0 }}
                              onClick={(e) => {
                                dispatch({
                                  type: 'SET_TOTAL_TIME_OPEN',
                                  payload: false,
                                });
                              }}
                            >
                              <KeyboardArrowUpIcon />
                            </IconButton>
                          ) : (
                            <IconButton
                              sx={{ m: 0, p: 0 }}
                              onClick={(e) => {
                                dispatch({
                                  type: 'SET_TOTAL_TIME_OPEN',
                                  payload: true,
                                });
                                dispatch({
                                  type: 'SET_TOTAL_VALUE_OPEN',
                                  payload: false,
                                });
                              }}
                            >
                              <KeyboardArrowDownIcon />
                            </IconButton>
                          )}
                        </Stack>
                        <Stack
                          sx={{}}
                          direction={'row'}
                          justifyContent='left'
                          alignItems='left'
                          width={280}
                          spacing={0.5}
                        >
                          {[15, 30, 45, 60].map((interval, index: number) => (
                            <Button
                              disabled={false || !state.ticketPost.isEditable}
                              sx={{ width: '20%', fontSize: 12, height: 26 }}
                              variant='contained'
                              key={index}
                              onClick={(e) => handleSetTime(e, interval)}
                            >
                              {interval === 60 ? '+1:00' : `+0:${interval}`}
                            </Button>
                          ))}

                          {/* Reset Button */}
                          {true && (
                            <Button
                              disabled={false || !state.ticketPost.isEditable}
                              sx={{ width: '20%', fontSize: 12, height: 26 }}
                              variant='contained'
                              color='secondary'
                              onClick={() => {
                                dispatch({
                                  type: 'SET_START_DATE',
                                  payload: dayjs(new Date()),
                                });
                                dispatch({
                                  type: 'SET_END_DATE',
                                  payload: dayjs(new Date()),
                                });
                                dispatch({
                                  type: 'SET_IS_DIRTY',
                                  payload: true,
                                });
                              }}
                            >
                              {t('Ticket.TicketCommunications.reset')}
                            </Button>
                          )}
                        </Stack>

                        {state.ticketPost.isTotalTimeOpen && (
                          <Grid
                            container
                            spacing={2}
                            sx={{
                              width: '100%',
                              flexDirection: 'column',
                              backgroundColor: 'primary.main',
                              borderRadius: 2,
                              ml: 0,
                              mt: 0,
                              zIndex: 1000,
                              position: 'relative',
                            }}
                          >
                            <Grid
                              item
                              xs={12}
                              sx={{
                                m: 0,
                                p: 0,
                                pl: 1,
                                pr: 2,
                                mt: 0,
                                backgroundColor: 'rgba(0, 0, 0, 0.2)',
                              }}
                            >
                              <Stack direction={'row'} sx={{}}>
                                <Typography
                                  sx={{
                                    pt: 0.7,
                                    width: 100,
                                    letterSpacing: 1,
                                    textAlign: 'center',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    fontWeight: 'bold',
                                    textTransform: 'capitalize',
                                    fontSize: 14,
                                  }}
                                >
                                  Start:
                                </Typography>

                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <DesktopDateTimePicker
                                    disabled={
                                      false || !state.ticketPost.isEditable
                                    }
                                    format='DD/MM/YYYY HH:mm'
                                    value={
                                      dayjs(
                                        state.ticketPost.ticketPost.startTime
                                      )
                                        ? state.ticketPost.ticketPost.startTime
                                        : dayjs(new Date())
                                    }
                                    onChange={(e) => {
                                      dispatch({
                                        type: 'SET_START_DATE',
                                        payload: dayjs(e),
                                      });
                                    }}
                                    ampm={false}
                                    views={[
                                      'year',
                                      'month',
                                      'day',
                                      'hours',
                                      'minutes',
                                    ]}
                                    slotProps={{
                                      textField: {
                                        sx: {
                                          '& .MuiInputBase-input': {
                                            fontSize: 14,
                                          },
                                          '& .MuiInputLabel-root': {
                                            fontSize: 14,
                                          },
                                        },
                                      } as any,
                                      openPickerIcon: {
                                        sx: {
                                          fontSize: 26,
                                        },
                                      } as any,
                                    }}
                                  />
                                </LocalizationProvider>
                              </Stack>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sx={{
                                m: 0,
                                p: 0,
                                pl: 1,
                                pr: 2,
                                mt: 0,
                                backgroundColor: 'rgba(0, 0, 0, 0.2)',
                              }}
                            >
                              <Stack direction={'row'} sx={{}}>
                                <Typography
                                  sx={{
                                    pt: 0.7,
                                    width: 100,
                                    letterSpacing: 1,
                                    textAlign: 'center',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    fontWeight: 'bold',
                                    textTransform: 'capitalize',
                                    fontSize: 14,
                                  }}
                                >
                                  {t('Ticket.TicketCommunications.end')}:
                                </Typography>
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <DesktopDateTimePicker
                                    disabled={
                                      false || !state.ticketPost.isEditable
                                    }
                                    format='DD/MM/YYYY HH:mm'
                                    value={
                                      dayjs(state.ticketPost.ticketPost.endTime)
                                        ? state.ticketPost.ticketPost.endTime
                                        : null
                                    }
                                    onChange={(e) => {
                                      dispatch({
                                        type: 'SET_END_DATE',
                                        payload: dayjs(e),
                                      });
                                    }}
                                    ampm={false}
                                    views={[
                                      'year',
                                      'month',
                                      'day',
                                      'hours',
                                      'minutes',
                                    ]}
                                    slotProps={{
                                      textField: {
                                        sx: {
                                          '& .MuiInputBase-input': {
                                            fontSize: 14,
                                          },
                                          '& .MuiInputLabel-root': {
                                            fontSize: 14,
                                          },
                                        },
                                      } as any,
                                      openPickerIcon: {
                                        sx: {
                                          fontSize: 26,
                                        },
                                      } as any,
                                    }}
                                  />
                                </LocalizationProvider>
                              </Stack>
                            </Grid>
                          </Grid>
                        )}
                      </Grid>

                      {/* ECONOMY VIEW */}
                      <Grid
                        item
                        xs={12}
                        sx={{
                          m: 0,
                          p: 0,
                          pl: 1,
                          pr: 1,
                          mt: 1,
                          backgroundColor: 'rgba(0, 0, 0, 0.1)',
                          borderRadius: 2,
                          height: 60,
                        }}
                      >
                        <Stack direction='row' spacing={0} flexGrow={1}>
                          <Typography sx={[TextStyle.label, { width: '60%' }]}>
                            {t('Ticket.TicketCommunications.economy')}
                          </Typography>
                          <Typography
                            sx={[TextStyle.value, { pr: 2, pt: 0.5 }]}
                          >
                            {(state.ticketPost.totalValue || 0).toFixed(2)}
                          </Typography>
                          {state.ticketPost.isTotalValueOpen ? (
                            <IconButton
                              sx={{ m: 0, p: 0 }}
                              onClick={(e) => {
                                dispatch({
                                  type: 'SET_TOTAL_VALUE_OPEN',
                                  payload: false,
                                });
                              }}
                            >
                              <KeyboardArrowUpIcon />
                            </IconButton>
                          ) : (
                            <IconButton
                              sx={{ m: 0, p: 0 }}
                              onClick={(e) => {
                                dispatch({
                                  type: 'SET_TOTAL_VALUE_OPEN',
                                  payload: true,
                                });
                              }}
                            >
                              <KeyboardArrowDownIcon />
                            </IconButton>
                          )}
                        </Stack>

                        {state.ticketPost.isTotalValueOpen && (
                          <Grid item xs={12} sx={{ m: 0, p: 0 }}>
                            {
                              <EconomyView
                                ticketPostBilling={
                                  state.ticketPost.ticketPostBilling
                                }
                                state={state.ticketPost}
                              />
                            }
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                {/* MESSAGE */}
                <Grid
                  container
                  spacing={0}
                  flexDirection={'row'}
                  sx={{ m: 0, p: 0, mt: 0 }}
                >
                  {/* NEW COMMUNICATION*/}

                  <Grid
                    item
                    xs={12}
                    sx={{
                      pl: 0.5,
                      pr: 0.5,
                      pt: 2,
                      backgroundColor: 'primary.main',
                    }}
                  >
                    {/*   <SearchFilter
                      Icon={TextsmsRoundedIcon}
                      Header={
                        isGuidEmpty(state.ticketPost.ticketPost.id)
                          ? `${t(
                              'Ticket.TicketCommunications.newCommunication'
                            )}`
                          : `${t(
                              'Ticket.TicketCommunications.editCommunication'
                            )}`
                      }
                      gfx={
                        <>
                          {state.ticketPost.ticketPost.isBilled ? (
                            <Typography
                              sx={{
                                zIndex: 11,
                                position: 'absolute',
                                left: 400,
                                color: 'error.main',
                              }}
                            >
                              {state.ticketPost.ticketPost.isBilled &&
                                t('Ticket.TicketCommunications.isBilled')}
                            </Typography>
                          ) : (
                            <></>
                          )}
                        </>
                      }
                      filterValue={state.ticketPost.ticketPost.status}
                      handleFilterChange={(e: any) => {
                        dispatch({
                          type: 'CHANGE_STATUS',
                          payload: e,
                        });
                        dispatch({
                          type: 'SET_IS_TICKET_POST_DIRTY',
                          payload: true,
                        });
                      }}
                      handleSearch={null}
                      selectList={ticketCommunicationStatus}
                    /> */}
                  </Grid>
                  {/* NEW SCHEDULE TIME*/}
                  {state.ticketPost.scheduleTime &&
                    (state.ticketPost.ticketPost.status === 1 ||
                      state.ticketPost.ticketPost.status === 3 ||
                      state.ticketPost.ticketPost.status === 4) && (
                      <Grid
                        item
                        xs={12}
                        sx={{
                          key: 'scheduleTime',
                          border: 1,
                          borderColor: 'primary.back',
                          backgroundColor: 'rgba(0, 0, 0, 0.1)',
                          p: 1,
                          mb: 2,
                        }}
                      >
                        <ScheduleView
                          scheduleTime={state.ticketPost.scheduleTime}
                          handleChange={handleChangeSchedule}
                        />
                      </Grid>
                    )}
                  <Grid item xs={12} sx={{ m: 0, pr: 0 }}>
                    <Grid
                      sx={{
                        flexGrow: 1,
                      }}
                    >
                      <Grid
                        sx={{
                          m: 0,
                          pb: 1,
                          flexGrow: 1,
                          backgroundColor: 'primary.back',
                          borderRadius: 2,
                        }}
                      >
                        {/* EMAIL TO */}
                        <Stack
                          direction='row'
                          spacing={0}
                          flexGrow={1}
                          sx={{
                            backgroundColor:
                              state.ticketPost.ticketPost.status === 3 ||
                              state.ticketPost.ticketPost.status === 4 ||
                              state.ticketPost.ticketPost.status === 5 ||
                              state.ticketPost.ticketPost.status === 6
                                ? 'success.dark'
                                : 'transparent',
                            border: 2,
                            borderColor:
                              state.ticketPost.ticketPost.status === 3 ||
                              state.ticketPost.ticketPost.status === 4 ||
                              state.ticketPost.ticketPost.status === 5 ||
                              state.ticketPost.ticketPost.status === 6
                                ? 'success.light'
                                : 'transparent',
                            borderRadius: 2,
                            mb: 2,
                          }}
                        >
                          {/* ======================= */}
                          {/* TICKETPOST: “TO” */}
                          {/* ======================= */}
                          <Grid item xs={12} sx={{ p: 0, pr: 1, mb: 4, ml: 2 }}>
                            <Autocomplete
                              multiple
                              freeSolo
                              options={[]}
                              value={toPostEmails || []}
                              inputValue={postToInput}
                              onInputChange={handleInputChange(
                                'TICKETPOST',
                                'TO'
                              )}
                              onChange={handleEmailsChange('TICKETPOST', 'TO')}
                              renderTags={(value, getTagProps) =>
                                value.map((email, index) => {
                                  const props = getTagProps({ index });
                                  const valid = emailRegex.test(email);
                                  return (
                                    <Chip
                                      {...props}
                                      variant='outlined'
                                      label={email}
                                      color={valid ? 'default' : 'error'}
                                      sx={
                                        valid
                                          ? {}
                                          : {
                                              borderColor: 'error.main',
                                              color: 'error.main',
                                            }
                                      }
                                    />
                                  );
                                })
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant='standard'
                                  label={t(
                                    'Ticket.TicketDetails.ticketTypes.to'
                                  )}
                                  onFocus={(e) => e.target.select()}
                                  onBlur={handleInputBlur('TICKETPOST', 'TO')}
                                  error={
                                    postToInput !== '' &&
                                    !emailRegex.test(postToInput)
                                  }
                                  helperText={
                                    postToInput !== '' &&
                                    !emailRegex.test(postToInput)
                                      ? 'Ugyldig e-post'
                                      : ''
                                  }
                                  sx={{
                                    '& .MuiInputBase-root.Mui-focused .MuiInputBase-input':
                                      {
                                        backgroundColor: 'rgba(0,0,0,0.2)',
                                      },
                                  }}
                                />
                              )}
                              sx={{ width: '95%', mt: -2.5 }}
                            />
                          </Grid>
                          <SwitchType
                            isChecked={state.ticketPost.ticketPost.isEmailSent}
                            dispatch={dispatch}
                            type={'IS_SEND_EMAIL'}
                            header={null}
                            showNotification={false}
                            disabled={
                              state.ticketPost.ticketPost.internal ||
                              !state.ticketPost.isEditable ||
                              !state.ticketPost.isEmailAllowed
                            }
                          />
                        </Stack>
                        {/* EMAIL CC */}
                        <Stack
                          direction='row'
                          spacing={0}
                          flexGrow={1}
                          sx={{
                            backgroundColor:
                              state.ticketPost.ticketPost.status === 3 ||
                              state.ticketPost.ticketPost.status === 4 ||
                              state.ticketPost.ticketPost.status === 5 ||
                              state.ticketPost.ticketPost.status === 6
                                ? 'success.dark'
                                : 'transparent',
                            border: 2,
                            borderColor:
                              state.ticketPost.ticketPost.status === 3 ||
                              state.ticketPost.ticketPost.status === 4 ||
                              state.ticketPost.ticketPost.status === 5 ||
                              state.ticketPost.ticketPost.status === 6
                                ? 'success.light'
                                : 'transparent',
                            borderRadius: 2,
                          }}
                        >
                          {/* ======================= */}
                          {/* TICKETPOST: “CC” */}
                          {/* ======================= */}
                          <Grid item xs={12} sx={{ p: 0, pr: 1, mb: 2, ml: 2 }}>
                            <Autocomplete
                              multiple
                              freeSolo
                              options={[]}
                              value={ccPostEmails || []}
                              inputValue={postCcInput}
                              onInputChange={handleInputChange(
                                'TICKETPOST',
                                'CC'
                              )}
                              onChange={handleEmailsChange('TICKETPOST', 'CC')}
                              renderTags={(value, getTagProps) =>
                                value.map((email, index) => {
                                  const props = getTagProps({ index });
                                  const valid = emailRegex.test(email);
                                  return (
                                    <Chip
                                      {...props}
                                      variant='outlined'
                                      label={email}
                                      color={valid ? 'default' : 'error'}
                                      sx={
                                        valid
                                          ? {}
                                          : {
                                              borderColor: 'error.main',
                                              color: 'error.main',
                                            }
                                      }
                                    />
                                  );
                                })
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant='standard'
                                  label={t(
                                    'Ticket.TicketDetails.ticketTypes.cc'
                                  )}
                                  onFocus={(e) => e.target.select()}
                                  onBlur={handleInputBlur('TICKETPOST', 'CC')}
                                  error={
                                    postCcInput !== '' &&
                                    !emailRegex.test(postCcInput)
                                  }
                                  helperText={
                                    postCcInput !== '' &&
                                    !emailRegex.test(postCcInput)
                                      ? 'Ugyldig e-post'
                                      : ''
                                  }
                                  sx={{
                                    '& .MuiInputBase-root.Mui-focused .MuiInputBase-input':
                                      {
                                        backgroundColor: 'rgba(0,0,0,0.2)',
                                      },
                                  }}
                                />
                              )}
                              sx={{ width: '95%', mt: -2.5 }}
                            />
                          </Grid>
                          <SwitchType
                            isChecked={state.ticketPost.ticketPost.isCCSent}
                            dispatch={dispatch}
                            type={'IS_SEND_EMAIL_CC'}
                            header={null}
                            showNotification={false}
                            disabled={
                              state.ticketPost.ticketPost.internal ||
                              !state.ticketPost.isEditable ||
                              !state.ticketPost.isEmailAllowed
                            }
                          />
                        </Stack>
                        <TextField
                          sx={{ m: 0, p: 0, backgroundColor: 'primary.main' }}
                          value={state.ticketPost.ticketPost.message}
                          label={t(
                            'Ticket.TicketCommunications.internalTicket'
                          )}
                          variant='filled'
                          multiline={true}
                          disabled={false || !state.ticketPost.isEditable}
                          minRows={12}
                          maxRows={12}
                          onChange={(e) => {
                            dispatch({
                              type: 'EDIT_COMMENT',
                              payload: e.target.value,
                            });
                          }}
                        />
                        <Stack
                          direction='row'
                          spacing={0}
                          flexGrow={1}
                          sx={{ backgroundColor: 'rgb', mb: 2 }}
                        >
                          <Typography
                            sx={{
                              m: 0,
                              p: 0,
                              pl: 2,
                              letterSpacing: 1,
                              alignSelf: 'center',
                              alignContent: 'center',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              textTransform: 'capitalize',
                              fontSize: 14,
                              flexGrow: 1,
                            }}
                          >
                            {t(
                              'Ticket.TicketCommunications.internalTicketMessage'
                            )}
                          </Typography>

                          <SwitchType
                            isChecked={state.ticketPost.ticketPost.internal}
                            dispatch={dispatch}
                            type={'SET_INTERNAL'}
                            header={null}
                            showNotification={false}
                            disabled={false || !state.ticketPost.isEditable}
                          />
                        </Stack>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Stack>
            </Grid>
            {/* ATTATCHMENTS */}
            <Grid item xs={12} sx={{ pr: 0.5, pl: 0.5, direction: 'row' }}>
              <Accordion
                disableGutters
                sx={{
                  backgroundColor: 'transparent',
                  border: 0,
                  m: 1,
                }}
              >
                <FormAccordionSummary
                  Icon={AttachFileIcon}
                  title={t('Ticket.TicketCommunications.attachments')}
                  FormJSX={
                    attachments.length > 0 ? (
                      <Badge
                        badgeContent={attachments.length}
                        color='secondary'
                        sx={{ mr: 1 }}
                      >
                        <AttachFileIcon />
                      </Badge>
                    ) : null
                  }
                />
                <AccordionDetails>
                  <DocumentUploader
                    setDocuments={(files: any) =>
                      setSelectedDocuments((prevDocs: any) => [
                        ...prevDocs,
                        ...files,
                      ])
                    }
                  />
                  <List>
                    {attachments.map((document: any, index: number) => (
                      <ListItem
                        key={index}
                        sx={{ display: 'flex', alignItems: 'center' }}
                      >
                        <AttachFileIcon
                          sx={{ mr: 1, color: 'secondary.main' }}
                        />
                        {document.url ? (
                          <a
                            rel='noopener noreferrer'
                            target='_blank'
                            href={document.url}
                            style={{
                              color: 'white',
                              textDecoration: 'underline',
                            }}
                          >
                            {document.fileName}
                          </a>
                        ) : (
                          <Typography>{document.file?.name}</Typography>
                        )}
                        {document.fileSize && (
                          <Chip
                            label={document.fileSize}
                            size='small'
                            sx={{ ml: 2 }}
                          />
                        )}
                      </ListItem>
                    ))}
                  </List>
                </AccordionDetails>
              </Accordion>
            </Grid>
          </List>
          {/* FOTTER */}
          {/* SUBMIT*/}
          <Grid item xs={12} sx={{ pr: 0.5, pl: 0.5, direction: 'row' }}>
            <Stack direction={'column'}>
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'right',
                }}
              >
                {isValidGuid(state.ticketPost.ticketPost.id) && (
                  <Button
                    sx={{
                      width: '25%',
                      backgroundColor: 'primary.back',
                    }}
                    onClick={(e: any) => {
                      e.preventDefault();
                      dispatch({
                        type: 'REMOVE_TICKET_POST',
                        payload: state.ticketPost.ticketPost.id,
                      });
                      dispatch({
                        type: 'SET_IS_EDITABLE',
                        payload: true,
                      });
                      dispatch({
                        type: 'SET_IS_TICKET_POST_DIRTY',
                        payload: false,
                      });
                      let workRole = GetWorkRole(
                        state.ticket.company?.workRole ?? null,
                        user.workRole,
                        state.ticketPost.ticketPost.workRole
                      );
                      // console.log('GetWorkRole w', workRole);
                      if (workRole) {
                        dispatch({
                          type: 'SET_WORK_ROLE',
                          payload: workRole,
                        });
                      }
                    }}
                    variant='contained'
                  >
                    {t('Ticket.TicketCommunications.Cancel')}
                  </Button>
                )}
                <Button
                  disabled={
                    !state.ticketPost.isEditable ||
                    !state.ticketPost.ticketPost.isDirty
                  }
                  sx={{
                    width: '50%',
                    // backgroundColor: 'secondary.main',
                  }}
                  type='submit'
                  onClick={(e: any) => {
                    e.preventDefault();
                    onTicketPostSubmit();
                    dispatch({
                      type: 'SET_IS_EDITABLE',
                      payload: false,
                    });
                  }}
                  id={
                    isGuidEmpty(state.ticketPost.ticketPost.id)
                      ? `${t('Ticket.TicketCommunications.submit')}`
                      : `${t('Ticket.TicketCommunications.confirmEdit')}`
                  }
                  variant='contained'
                >
                  {isGuidEmpty(state.ticketPost.ticketPost.id)
                    ? `${t('Ticket.TicketCommunications.submit')}`
                    : `${t('Ticket.TicketCommunications.confirmEdit')}`}
                </Button>
              </Box>
            </Stack>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
